import React from 'react'

//------------------- Global -------------------
export const months = {  
                        1 : {key:"jan", name:"January"},
                        2 : {key:"feb", name:"February"},
                        3 : {key:"mar", name:"March"},
                        4 : {key:"apr", name:"April"},
                        5 : {key:"may", name:"May"},
                        6 : {key:"jun", name:"June"},
                        7 : {key:"jul", name:"July"},
                        8 : {key:"aug", name:"August"},
                        9 : {key:"sep", name:"September"},
                        10 : {key:"oct", name:"October"},
                        11 : {key:"nov", name:"November"},
                        12 : {key:"dec", name:"December"}
                        };

export const monthByNumber = (number) => {
    return months[number];
}

//------------------- Budget -------------------
export const tblColsHistory = [{
        title: 'Year',
        dataIndex: 'year',
        width: 80,
        fixed: 'left',
    }, {
        title: 'Created by',
        dataIndex: 'created_by',
        width: 200,
    }, {
        title: 'Creation Date',
        dataIndex: 'created_at',
        width: 100,
    }, {
        title: 'Period',
        dataIndex: 'period',
        width: 100,
    }, {
        title: 'Growth',
        dataIndex: 'growth',
        width: 80,
    }, {
        title: 'Capture Format',
        dataIndex: 'capture_format',
        width: 100,
    }, {
        title: 'Reference year',
        dataIndex: 'reference_year',
        width: 90,
    },{    
        title: 'Actions',
        dataIndex: 'actions',
        width: 100,
        fixed: 'right',
    }];

    export const tblColsNewBudget = (budget_year,reference_year, budget_period,budget_depth) => {
        let childs=[];
        childs = [{
            title: budget_depth.title,
            dataIndex: budget_depth.key,
            key: budget_depth.key+"main",
            width: 200,
            fixed: 'left',
            }];


        switch(budget_period.key){
            case "year":
                childs.push({
                    title: budget_period.title,
                    dataIndex: budget_depth.key+"1",
                    key: budget_depth.key+"col1",
                    width: 120,
                    align : "center"
                  });
                
                break;
            case "month":
                
                Object.keys(months).map((key) => {
                    childs.push({
                        title: months[key].name,
                        dataIndex: budget_depth.key+key,
                        key: budget_depth.key+"col"+key,
                        width: 120,
                        align : "center"
                    });
                });

                break;
            case "day":
                
                for (let i = 1; i < 366; i++) {
                    childs.push({
                        title: i,
                        dataIndex: budget_depth.key+i,
                        key: budget_depth.key+"col"+i,
                        width: 120,
                        align : "center"
                    });
                } 

                break;

        }

        return childs;
   
    }


// WEBPACK FOOTER //
// ./src/Setup/config/Helpers.js